import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { Link, useParams } from "react-router-dom";
import FixedBtn from "../../module/fixed_btn/fixed_btn";
import MainFooter from "../../module/footer/main_footer";
import SubNavBar from "../../module/nav_bar/sub_nav_bar";
import ReviseChargePage from "./revise_charge_page";
import "./charge_page.css";
import LoaderOverlay from "../loading_page/loading_page";
import axios from "axios";
import _, { set } from "lodash";

function isEmptyOrSpaces(input: any) {
  return _.isEmpty(_.trim(input));
}

function priceFormatting(input: number): string {
  if (isEmptyOrSpaces(input)) return "";
  return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function ChargePage() {
  const [chargeInfo, setChargeInfo] = useState<any>({});
  const [cookie, setCookie] = useCookies(["admin"]);
  const [isLoading, setIsLoading] = useState(true);
  const { contents } = useParams();

  useEffect(() => {
    const getChargeAPI = process.env.REACT_APP_SERVER_URI + "/charge";

    setIsLoading(true);

    axios
      .get(getChargeAPI, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const info = res.data.foundCharge;
        setChargeInfo(info);
      })
      .catch((error) => {
        alert(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [contents]);

  const revise_btn = (
    <span>
      <button className="revise_btn">
        <Link to="/charge/revise">수정</Link>
      </button>
    </span>
  );

  let content, title;
  if (contents === "revise") {
    content = <ReviseChargePage />;
    title = "이용요금 수정";
  } else if (contents === "table") {
    content = (
      <div className="charge_container">
        <div className="limit_container">
          <table className="charge_table" id="limit">
            <caption id="limit_title">
              장기요양 등급별 월 한도액 및 본인부담률
            </caption>
            <thead>
              <tr>
                <th>장기요양등급</th>
                <th>1등급</th>
                <th>2등급</th>
                <th>3등급</th>
                <th>4등급</th>
                <th>5등급</th>
                <th id="copay">본인부담율</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>월 한도액 (원)</th>
                <td>
                  {priceFormatting(chargeInfo === null ? "" : chargeInfo.first)}
                </td>
                <td>
                  {priceFormatting(
                    chargeInfo === null ? "" : chargeInfo.second
                  )}
                </td>
                <td>
                  {priceFormatting(chargeInfo === null ? "" : chargeInfo.third)}
                </td>
                <td>
                  {priceFormatting(
                    chargeInfo === null ? "" : chargeInfo.fourth
                  )}
                </td>
                <td>
                  {priceFormatting(chargeInfo === null ? "" : chargeInfo.fifth)}
                </td>
                <td id="copay">
                  일반대상자: {chargeInfo === null ? "" : chargeInfo.normal}%
                  <br />
                  경감대상자: {chargeInfo === null ? "" : chargeInfo.reduce}%
                  <br />
                  의료대상자: {chargeInfo === null ? "" : chargeInfo.medical}%
                  <br />
                  기초생활수급권자:{" "}
                  {chargeInfo === null ? "" : chargeInfo.basic}%
                </td>
              </tr>
            </tbody>
            <thead className="responsive" hidden>
              <th>대상</th>
              <th>일반대상자</th>
              <th>경감대상자</th>
              <th>의료대상자</th>
              <th>기초생활수급권자</th>
            </thead>
            <tbody className="responsive" hidden>
              <tr>
                <th>본인부담율(%)</th>
                <td>{chargeInfo === null ? "" : chargeInfo.normal}%</td>
                <td>{chargeInfo === null ? "" : chargeInfo.reduce}%</td>
                <td>{chargeInfo === null ? "" : chargeInfo.medical}%</td>
                <td>{chargeInfo === null ? "" : chargeInfo.basic}%</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="pay_container">
          <table className="charge_table" id="pay">
            <caption id="pay_title">
              방문요양 서비스의 급여비용 산정기준
            </caption>
            <thead>
              <tr>
                <th>분류</th>
                <th>금액 (원)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>30분 이상</td>
                <td>
                  {priceFormatting(chargeInfo === null ? "" : chargeInfo.M30)}
                </td>
              </tr>
              <tr>
                <td>60분 이상</td>
                <td>
                  {priceFormatting(chargeInfo === null ? "" : chargeInfo.M60)}
                </td>
              </tr>
              <tr>
                <td>90분 이상</td>
                <td>
                  {priceFormatting(chargeInfo === null ? "" : chargeInfo.M90)}
                </td>
              </tr>
              <tr>
                <td>120분 이상</td>
                <td>
                  {priceFormatting(chargeInfo === null ? "" : chargeInfo.M120)}
                </td>
              </tr>
              <tr>
                <td>150분 이상</td>
                <td>
                  {priceFormatting(chargeInfo === null ? "" : chargeInfo.M150)}
                </td>
              </tr>
              <tr>
                <td>180분 이상</td>
                <td>
                  {priceFormatting(chargeInfo === null ? "" : chargeInfo.M180)}
                </td>
              </tr>
              <tr>
                <td>210분 이상</td>
                <td>
                  {priceFormatting(chargeInfo === null ? "" : chargeInfo.M210)}
                </td>
              </tr>
              <tr>
                <td>240분 이상</td>
                <td>
                  {priceFormatting(chargeInfo === null ? "" : chargeInfo.M240)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {_.isEmpty(cookie) ? <></> : revise_btn}
      </div>
    );

    title = "이용요금";
  }

  return (
    <div className="charge_page">
      <nav>
        <SubNavBar />
      </nav>
      <div className="page_header">
        <div className="page_title">{title}</div>
      </div>
      <main className="charge_main">{content}</main>
      <FixedBtn />
      <footer>
        <MainFooter />
      </footer>

      <LoaderOverlay open={isLoading} text="데이터를 불러오는 중입니다" />
    </div>
  );
}

export default ChargePage;
